import { tickerItems } from "@/mocks/home";

export default function TickerBar() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full overflow-hidden border-b border-primary-700 bg-primary-600 py-2 text-background-50">
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {loop.map((text, index) => (
          <span key={`${text}-${index}`} className="flex items-center gap-3 font-label text-xs md:text-sm">
            <i className="ri-flashlight-fill text-accent-300" />
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}